import React, { useEffect, useRef } from 'react';
import vitelwireless2 from "../landing-images/newLogo.png";
import { FaBars, FaTimes, FaPhone } from 'react-icons/fa';
import "./headerStyle.css";

const LandingHeader = ({ menuOpen, setMenuOpen }) => {
  const headerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY > 50) {
          headerRef.current.classList.add('header-scrolled');
        } else {
          headerRef.current.classList.remove('header-scrolled');
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="site-header" ref={headerRef}>
      <div className="header-top">
        <a href="tel:08037773444" className="header-phone">
          <FaPhone className="phone-icon" /> For support: 2347120000071
        </a>
      </div>
      <div className="header-main">
        <div className="header-logo">
          <a href="/#hero">
            <img src={vitelwireless2} alt="Vitel Wireless" />
          </a>
        </div>
        <nav className={`header-nav ${menuOpen ? 'nav-open' : ''}`}>
          <a href="/#hero" onClick={() => setMenuOpen(false)}>Home</a>
          <a href="/#services" onClick={() => setMenuOpen(false)}>Solutions</a>
          <a href="/#features" onClick={() => setMenuOpen(false)}>Why Us</a>
          <a href="/#services" className="nav-cta" onClick={() => setMenuOpen(false)}>Sign In</a>
        </nav>
        <button
          className="mobile-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
      {menuOpen && <div className="mobile-overlay" onClick={() => setMenuOpen(false)} />}
    </header>
  );
};

export default LandingHeader;
